import script from "./LearnerWorkpacketDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./LearnerWorkpacketDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./LearnerWorkpacketDetailPage.vue?vue&type=style&index=0&id=a8029e74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8029e74"]])

export default __exports__